import courseActions from "./actions";
import { put, call, takeEvery, all, delay } from "redux-saga/effects";
import { API_URL } from "../../utils/constants";
import axios from "axios";
import commonActions from "../common/actions";
import Cookies from "js-cookie";
import eligibilityCriteriaActions from "./actions";

const eligibilityCriteriaSagas = function* () {
  yield all([
    yield takeEvery(eligibilityCriteriaActions.GET_ELIGIBILITY_CRITERIA, getEligibilityCriteria),
    yield takeEvery(eligibilityCriteriaActions.CREATE_ELIGIBILITY_CRITERIA, createEligibilityCriteria),
    yield takeEvery(eligibilityCriteriaActions.UPDATE_ELIGIBILITY_CRITERIA, updateEligibilityCriteria),
    yield takeEvery(eligibilityCriteriaActions.SET_ACTIVE_ELIGIBILITY, setActiveEligibility),

  ]);
};


const getEligibilityCriteria = function* (data) {
    const { payload } = data;
  
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
    try {
      const result = yield call(() =>
        axios.get(`${API_URL}/backoffice/eligibility-criteria/get-eligibility`)
      );
      if (result) {
        yield put({
          type: eligibilityCriteriaActions.SET_ELIGIBILITY_CRITERIA,
          payload: result?.data?.result,
        });
      }
      yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    } catch (err) {
    }
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  };
  



const createEligibilityCriteria = function* (data) {
  const { payload } = data;
  const { navigate, } = payload;

  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/backoffice/eligibility-criteria/create-eligibility`, payload?.data)
    );
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    if (result?.data?.statusCode === 200) {
      navigate(
        `/${Cookies.get("mhet_mst_project")}/eligibility-management?page=eligibilitycriteria`
      );
      yield put({ type: eligibilityCriteriaActions.GET_ELIGIBILITY_CRITERIA });
    }
   
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
     ;
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};


const updateEligibilityCriteria = function* (data) {
  const { payload } = data;
  const { navigate, } = payload;


  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.put(
        `${API_URL}/backoffice/eligibility-criteria/update-eligibility/${payload?.data?.eligibilitycriteriaid}`,
        payload?.data
      )
    );
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });

    if (result?.data?.statusCode === 200) {
      navigate(
        `/${Cookies.get("mhet_mst_project")}/eligibility-management?page=eligibilitycriteria`
      );
    }

    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
     ;
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const setActiveEligibility = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.put(
        `${API_URL}/backoffice/eligibility-criteria/updateactive/${payload?.data?.eligibilitycriteriaid}`,
        payload?.data
      )
    );
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    if (result?.data?.statusCode === 200) {
      yield put({ type: eligibilityCriteriaActions.GET_ELIGIBILITY_CRITERIA });
      yield put({
        type: commonActions.SET_SHOW_MODAL,
        payload: { show: false, type: null, method: null, data: null },
      });
    }
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
     ;
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};



export default eligibilityCriteriaSagas;
